import { render } from "./Videos.vue?vue&type=template&id=d7b0f6a8&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"

import "./Videos.vue?vue&type=style&index=0&id=d7b0f6a8&scoped=true&lang=scss"

import exportComponent from "/Users/spineup/Downloads/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b0f6a8"]])

export default __exports__